var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCzechRepublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "czech republic",
    clipPath: "url(#clip0_1730_8001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.75 16.7778C31.75 25.4763 24.6985 32.5278 16 32.5278C7.30151 32.5278 0.25 25.4763 0.25 16.7778C0.25 8.07935 7.30151 1.02783 16 1.02783C24.6985 1.02783 31.75 8.07935 31.75 16.7778Z",
    fill: "#F0F0F0",
    stroke: "#ABABAB",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.609 16.7778C14.609 16.7778 4.6959 28.0938 4.68652 28.0915C7.5819 30.987 11.582 32.7778 16.0003 32.7778C24.8368 32.7778 32.0003 25.6143 32.0003 16.7778H14.609Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.68628 5.46411C-1.56209 11.7125 -1.56209 21.8432 4.68628 28.0916C7.26834 25.5095 9.75166 23.0262 16 16.7779L4.68628 5.46411Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1730_8001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.777832)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCzechRepublic);
export default __webpack_public_path__ + "static/media/czech-republic.2f6f62b49b896c0add79f17839ffa92e.svg";
export { ForwardRef as ReactComponent };